export const FEATURES_CONSTANTS = {
  title: "Key benefits of Certification Labs",
  list: [
    {
      label: "Realistic Simulations",
      text: "Access to environments that closely mimic actual IT infrastructures, providing practical experience.",
    },
    {
      label: "On-Demand Availability",
      text: "Users can access labs anytime, accommodating various schedules and learning paces.",
    },
    {
      label: "Diverse Scenarios",
      text: "A wide range of exercises covering different technologies and certification requirements.",
    },
    {
      label: "Guided Learning Paths",
      text: "Structured modules that align with certification curricula, offering a clear progression.",
    },
    {
      label: "Performance Tracking",
      text: "Tools to monitor progress, identify strengths, and address areas needing improvement.",
    },
    {
      label: "Resource Libraries",
      text: "Access to supplementary materials, such as documentation and tutorials, to support learning.",
    },
    {
      label: "Secure Environment",
      text: "Isolated labs ensure a safe space for experimentation without affecting live systems.",
    },
  ],
};
